jQuery(function(){
  function _init(){
    cacheDom()
    // if($searchParams.get("cb") != null){
    //   renderCustomCrumbs()
    // } else if($searchParams.get("f") != null || $(`.site-nav--current > a`).length == 0){
    //   renderFilterNav()
    // }
    if(($searchParams.get("m") == 'category' || $(`.site-nav--current > a`).length == 0) && $('.custom-breadcrumb').length <= 0){
      renderFilterNav()
    }else{
      render()
    }

    if($('.template-product').length > 0){
      $el_crumbs.append(`<span aria-hidden="true" class="breadcrumb__sep">&rsaquo;</span><a href="javascript:void()">${$('.product-single__title').text()}</a>`)
    }

    breadcrumbJsonLd()
  }
  function cacheDom(){
    $el_crumbs = $('.crumbs')
    $searchParams = new URLSearchParams(window.location.search)
  }
  function render(){
    let active_link = $(`.site-nav .site-nav--current`)

    const iterateBreadcrumb = (index) => {
      if(index == 0)
        return
      let el = $(`.site-nav [data-index=${index}]`)
      iterateBreadcrumb(el.attr('data-parent'))
      appendCrumb($(`.site-nav li[data-index=${index}] > a`))
    }
    if(active_link.length > 0)
      iterateBreadcrumb(active_link.attr('data-index'))
  }

  function renderFilterNav(){

    let active_link = $(`.search-filter-popup .filter-active`)
    
    const iterateBreadcrumb = (index) => {
      if(index == 0)
        return
      let el = $(`.search-filter-popup [data-index=${index}]`)
      iterateBreadcrumb(el.attr('data-parent'))
      appendCrumbFilter($(`.search-filter-popup [data-index=${index}] > a`))
    }
    if(active_link.length > 0 && active_link.attr('data-index'))
      iterateBreadcrumb(active_link.attr('data-index'))

  }

  
  function appendCrumb(activeLink){
    
    // let txt = $(activeLink.find("span").length>1?activeLink.find("span")[0]:activeLink[0]).text().trim()
    let txt = activeLink.text()
    let hrf = activeLink.attr('href')
    let crumb = `<span aria-hidden="true" class="breadcrumb__sep">&rsaquo;</span><a href="${hrf}">${txt}</a>`
    $el_crumbs.append(crumb)
  }
  function appendCrumbFilter(activeLink){
    
    let txt = $(activeLink).find('.filter-title').text()
    let hrf = activeLink.attr('href')
    var href = new URL(window.location.origin+hrf);
    href.searchParams.set('m', 'category')
    let crumb = `<span aria-hidden="true" class="breadcrumb__sep">&rsaquo;</span><a href="${href}">${txt}</a>`
    $el_crumbs.append(crumb)
  }

  function breadcrumbJsonLd(){
    
    console.log("breadcrumb loading");
    const breadcrumbNav = document.querySelector("nav.breadcrumb");
      if (!breadcrumbNav) return;
      console.log("breadcrumb loaded")

      // Select all breadcrumb links except javascript:void()
      const links = breadcrumbNav.querySelectorAll("a[href]:not([href='javascript:void()'])");

      // Build JSON-LD structure
      const breadcrumbList = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": []
      };

      // Add each breadcrumb link
      links.forEach((link, index) => {
        breadcrumbList.itemListElement.push({
          "@type": "ListItem",
          "position": index + 1,
          "name": link.textContent.trim(),
          "item": link.href
        });
      });

      // Add current page (last breadcrumb text)
      const lastCrumb = breadcrumbNav.querySelector("a[href='javascript:void()'], .breadcrumb__sep + a:last-child");
      if (lastCrumb) {
        breadcrumbList.itemListElement.push({
          "@type": "ListItem",
          "position": breadcrumbList.itemListElement.length + 1,
          "name": lastCrumb.textContent.trim(),
          "item": window.location.href
        });
      }

      // Inject JSON-LD schema into <head>
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(breadcrumbList, null, 2);
      document.head.appendChild(script);
  }
  
  _init()
})